import firebase from './firebase/Settings';
import * as initState from '../store/initialState';
import { users } from './firebase/Collections';
// Firebase references
export const auth = firebase.auth();
// 
// Auth methods
// 
export const onAuthStateChanged = (props) => {
    const { setState, setProfile, handleModals } = props;
    const setUserState = (user) => {
        setState({ ...initState.state, user });
    }
    auth.onAuthStateChanged(async (user) => {
        // If it's a first time user
        if (!user) {
            setState(initState.state);
            setProfile(initState.profile);
            handleModals('terms', true);
        } else if (user.isAnonymous) {
            setUserState(user);
            setProfile(initState.profile);
            handleModals('login', false)
        } else if (!user.isAnonymous && user.displayName === null) {
            setUserState(user);
        } else if (!user.isAnonymous && user.displayName !== null) {
            setUserState(user);
            getUserData(user, setProfile)
                .then((data) => {
                    updateProfile_db(data, user)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    });
}
export const signInAnonymously = (handleOpen) => {
    auth.signInAnonymously()
        .then(() => handleOpen())
        .catch((error) => console.log(error.message))
}
export const signInWithEmailAndPassword = (email, password, switchStatus, handleOpen) => {
    auth.signInWithEmailAndPassword(email, password)
        .then(() => handleOpen())
        .catch((err) => {
            if (err.code === 'auth/user-not-found') {
                window.alert(err.message);
                switchStatus();
            } else {
                window.alert(err.message);
            }
        })
}
export const signOut = (history) => {
    auth.signOut()
    history.push('/')
}
export const sendEmailVerification = () => {
    var user = auth.currentUser;
    if (user !== null) {
        user.sendEmailVerification()
            .then(() => window.alert('A verification email has been sent. Please click the link and then refresh this page.'))
            .catch((error) => window.alert(error.message));
    }
}
// 
// User methods
// 
export const getUserData = (user, setProfile) => {
    return new Promise((resolve, reject) => {
        users.doc(user.uid).onSnapshot((doc) => {
            if (doc.data() !== undefined) {
                setProfile(doc.data())
                resolve(doc.data())
            } else {
                reject('No doc for this user.');
            }
        }, (err) => {
            reject(err.message)
        })
    })
}
const newUserObj = (user) => {
    const { displayName, email, emailVerified, uid } = user;
    return {
        profile: {
            displayName, email, emailVerified, uid,
        },
        settings: {
            appBarBackground: '',
            favoriteFont: '',
            storyPaper: '',
            "Primary Background": '#282c34',
            "Secondary Background": 'white'
        }
    }
}
export const createUserWithEmailAndPassword = (email, password, handleOpen) => {
    auth.createUserWithEmailAndPassword(email, password)
        .then(() => sendEmailVerification())
        .then(() => handleOpen())
        .catch((err) => window.alert(err.message))
}
export const createUserProfile_db = (user, handleOpen) => {
    let data = newUserObj(user);
    users.doc(user.uid).set(data)
        .then(() => handleOpen())
        .catch((error) => console.log(error.message))
}
export const updateProfile = (user, name) => {
    return new Promise((resolve, reject) => {
        user.updateProfile({ displayName: name })
            .then(() => resolve(true))
            .catch((error) => reject(error.message));
    })
}
export const updateEmail = (user, email) => {
    return new Promise((resolve, reject) => {
        user.updateEmail(email)
            .then(() => resolve(true))
            .catch((error) => reject(error.message));
    })
}
export const updatePassword = (newPassword) => {
    var user = auth.currentUser;
    return new Promise((resolve, reject) => {
        user.updatePassword(newPassword)
            .then(() => resolve("Password has been updated"))
            .catch((error) => reject(error.message));
    })
}
export const updateProfile_db = (profile, user) => {
    const { displayName, email, emailVerified, uid } = user;
    users.doc(user.uid).update({
        ...profile,
        profile: {
            displayName, email, emailVerified, uid
        }
    })
        .catch((error) => console.log(error.message))
}
export const deleteUser = (history, modals, reducers) => {
    var user = auth.currentUser;
    user.delete()
        .then(() => history.push('/'))
        .catch((err) => {
            window.alert(err.message);
            reducers.handleModals('deleteAccount', modals.deleteAccount ? false : true)
            reducers.handleModals('login', modals.login ? false : true)
        })
}
export const deleteUser_db = (uid) => {
    return new Promise((resolve, reject) => {
        users.doc(uid).delete()
            .then(() => resolve(true))
            .catch(() => reject(false))
    })
}